import type { FC } from 'react'
import React, { useMemo } from 'react'
import { OneModal } from '@yy/one-ui'
import Container from '../../Context'
import { useTranslation } from '../../hooks'
import styles from './index.module.less'
import List from './List'
import ReportForm from './ReportForm'

const powerMap = {
  oneship: 'OneShip',
  oneclub: 'OneClub',
}

const getPowerBy = () => {
  const key = Object.keys(powerMap).find((key) => location.hostname.includes(key))

  return powerMap[key] || powerMap['oneship']
}

export const powerBy = getPowerBy()

const MenuDialog: FC<React.ComponentProps<typeof OneModal>> = ({ visible, onCancel }) => {
  const { setType, type, form } = Container.useContainer()
  const { t } = useTranslation()

  const content = useMemo(() => {
    if (!type) return <List onClick={setType} />

    return <ReportForm form={form} />
  }, [form, setType, type])

  return (
    <OneModal wrapClassName={styles.modal} maskClosable={false} title={t('feedback.title')} width="auto" visible={visible} footer={false} onCancel={onCancel}>
      <div className={styles.content}>{content}</div>
      <div className={styles.powerBy}>
        <span>Powered by</span>
        <span>{powerBy}</span>
      </div>
    </OneModal>
  )
}

export default MenuDialog
